import { useNavigate } from "@tanstack/solid-router";
import { onMount } from "solid-js";

import { isAuthenticated } from "~/lib/auth";

export function HomeRedirect() {
  const navigate = useNavigate();

  onMount(() => {
    // Real auth: → /workspaces (selector). Dev mode (no auth, but VITE_DEV_USER_ID set):
    // jump straight to the default workspace's home for fast iteration.
    if (isAuthenticated()) {
      void navigate({ to: "/workspaces" });
    } else if (import.meta.env.VITE_DEV_USER_ID) {
      const ws = import.meta.env.VITE_DEFAULT_WORKSPACE_KEY ?? "default";
      void navigate({ to: "/workspaces/$wsKey", params: { wsKey: ws } });
    } else {
      void navigate({ to: "/login" });
    }
  });

  return <div class="flex items-center justify-center h-screen text-base-content/60">Loading…</div>;
}
